var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17032 1.98798C6.47131 0.670672 8.23457 0.670673 8.53556 1.98798C8.72999 2.83895 9.64759 3.24278 10.3514 2.78714C11.4409 2.08179 12.6877 3.40653 12.0239 4.56414C11.595 5.31194 11.9751 6.28688 12.776 6.49347C14.0158 6.81327 14.0158 8.68673 12.776 9.00653C11.9751 9.21312 11.595 10.1881 12.0239 10.9359C12.6877 12.0935 11.4409 13.4182 10.3514 12.7129C9.64759 12.2572 8.72999 12.6611 8.53556 13.512C8.23457 14.8293 6.47131 14.8293 6.17032 13.512C5.97589 12.6611 5.0583 12.2572 4.35448 12.7129C3.26497 13.4182 2.01816 12.0935 2.68201 10.9359C3.11085 10.1881 2.73077 9.21312 1.92987 9.00653C0.690045 8.68673 0.690045 6.81327 1.92986 6.49347C2.73077 6.28688 3.11085 5.31194 2.68201 4.56414C2.01816 3.40653 3.26497 2.08179 4.35448 2.78714C5.0583 3.24278 5.97589 2.83895 6.17032 1.98798Z",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47059 7.75C9.47059 8.99264 8.52248 10 7.35294 10C6.1834 10 5.23529 8.99264 5.23529 7.75C5.23529 6.50736 6.1834 5.5 7.35294 5.5C8.52248 5.5 9.47059 6.50736 9.47059 7.75Z",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.85330f143f8381ba4d9587fff1963b3f.svg";
export { ForwardRef as ReactComponent };